<template>
  <div class="wg-row container">
    <canvas 
        id="anm22-board-canvas"
        @mousedown="engage($event)"
        @mouseup="disengage"
        @mousemove="putPoint($event)"
        @touchstart="engage($event, true)"
        @touchend="disengage"
        @touchmove="putPoint($event, true)"
    ></canvas>
    <div class="wg-row" style="justify-content:center;margin-top:20px;">
      <button v-if="saveFn"  class="small" @click="saveFn(canvas.toDataURL())">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Confirm', 'Conferma') }}
        </div>
      </button>
      <button class="small" @click="clear" style="margin-left:20px;">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Reset', 'Reset') }}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 400,
    },
    color: {
      type: String,
      default: '#000',
    },
    radius: {
      type: Number, 
      default: 2,
    },
    saveFn: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      canvas: null,
      ctx: null,
      dragging: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  methods: {
    putPoint(e, touch) {
      if (this.dragging) {
        let rect = this.canvas.getBoundingClientRect();
        let x, y;
        if(touch) {
          e.preventDefault();
          x = e.touches[0].clientX - rect.left;
          y = e.touches[0].clientY - rect.top;
        } else {
          x = e.clientX - rect.left;
          y = e.clientY - rect.top;
        }
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
        this.ctx.beginPath();
        this.ctx.arc(x, y, this.radius, 0, Math.PI * 2);
        //context.arc(e.offsetX, e.offsetY, radius, 0, Math.PI*2);
        this.ctx.fill();
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
      }
    },
    engage(e, touch) {
      this.dragging = true;
      this.putPoint(e, touch);
    },
    disengage() {
      this.dragging = false;
      this.ctx.beginPath();
    },
    clear() {
      this.ctx.clearRect(0, 0, this.width, this.height);
    },
    resize() {
      const image = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      this.ctx.putImageData(image, 0, 0);
      this.ctx.fillStyle = this.color;
      this.ctx.strokeStyle = this.color;
      this.ctx.lineWidth = this.radius * 2;
    }
  },
  created() {},
  mounted() {
    this.canvas = document.getElementById("anm22-board-canvas");
    this.ctx = this.canvas.getContext("2d");
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.ctx.lineWidth = this.radius * 2;
    this.ctx.fillStyle = this.color;
    this.ctx.strokeStyle = this.color;
  },
  watch: {
    width(newVal, old) {
      this.resize();
    },
    height(newVal, old) {
      this.resize();
    },
  },
  components: {
    "vue-simple-spinner": Spinner,
  },
};
</script>

<style lang="scss" scoped>
.container {
  flex-direction: column;
}
</style>
